import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { Icon } from 'ui';
import moment from 'moment';
import DateInputButton from './DateInputButton';

const DueDatePicker = ({
  dateFormat = 'MM/DD/YYYY',
  minDate = moment(),
  onChange,
}) => {
  const [dueDate, setDueDate] = useState(null);

  const updateDueDate = date => {
    setDueDate(date);
    onChange(date);
  };

  const setDueDateTomorrow = () => {
    updateDueDate(moment().add(1, 'days'));
  };

  const clearDueDate = () => {
    updateDueDate(null);
  };

  return (
    <div>
      <div className="AssignModal-dateField">
        <DatePicker
          selected={dueDate}
          dateFormat={dateFormat}
          onChange={updateDueDate}
          minDate={minDate}
          customInput={<DateInputButton />}
        />
        <Icon name="calendar" />
      </div>
      {!dueDate && (
        <DateModifier onClick={setDueDateTomorrow}>Tomorrow</DateModifier>
      )}
      {dueDate && (
        <DateModifier onClick={clearDueDate}>No Due Date</DateModifier>
      )}
    </div>
  );
};

const DateModifier = props => (
  <button
    {...props}
    type="button"
    className="AssignModal-dateModifier u-linkBtn c-brand-blue"
  />
);

export default DueDatePicker;
